<div [ngClass]="{'tm-multi-checkbox':label}" [id]="random_id">
  <!-- <mat-label *ngIf="label" class="col-form-label" [ngClass]="{'req':mandatory}"
    [innerHtml]="label | HTMLFormatter |translate">
  </mat-label> -->
  <div class="">

    <span class="checkbox-item" [ngClass]="ng_class">
      <ng-container>
        <span class="checkbox-label pointer" [ngClass]="{'active':form_group.get([this.form_control]).value}"
          (click)="onSelect()">
          <i class="fa checkbox-icons m-auto"
            [ngClass]="{'fa-check-square-o': form_group.get([this.form_control]).value, 'fa-square-o': !form_group.get([this.form_control]).value}"></i>
          <span class="checkbox-title">
            {{ label}}
          </span>

        </span>

      </ng-container>
    </span>



  </div>
</div>
